import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

export function useDisputesSla(thresholdHours = 72) {
  return useQuery({
    queryKey: ['admin', 'disputes', 'sla', thresholdHours],
    queryFn: async () => {
      const token = localStorage.getItem('token');
      const { data } = await axios.get(
        `${API_BASE}/api/admin/disputes/sla-watch?threshold_hours=${thresholdHours}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return data;
    },
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
}
